import { render, staticRenderFns } from "./working-document-form.vue?vue&type=template&id=4df062a6&"
import script from "./working-document-form.vue?vue&type=script&lang=js&"
export * from "./working-document-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports